import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Collapse Icon Component
 * Arrows pointing inward from all four corners toward center
 * Used for collapse/minimize actions
 * HeroIcons mini style (20x20, filled)
 */
class CollapseIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20',
            fill: 'currentColor',
            stroke: 'none',
        };
    }

    renderIconPath() {
        return svg`
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.22 3.22a.75.75 0 011.06 0l3.22 3.22V4.25a.75.75 0 011.5 0v4a.75.75 0 01-.75.75h-4a.75.75 0 010-1.5h2.19L3.22 4.28a.75.75 0 010-1.06zm13.56 0a.75.75 0 010 1.06l-3.22 3.22h2.19a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75v-4a.75.75 0 011.5 0v2.19l3.22-3.22a.75.75 0 011.06 0zM3.22 16.78a.75.75 0 010-1.06l3.22-3.22H4.25a.75.75 0 010-1.5h4a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-2.19l-3.22 3.22a.75.75 0 01-1.06 0zm13.56 0a.75.75 0 01-1.06 0l-3.22-3.22v2.19a.75.75 0 01-1.5 0v-4a.75.75 0 01.75-.75h4a.75.75 0 010 1.5h-2.19l3.22 3.22a.75.75 0 010 1.06z"
            />
        `;
    }
}

customElements.define('collapse-icon', CollapseIcon);
